module.exports = __webpack_public_path__ + "static/media/IMG_1324.805abff6.jpg";